import React from "react";

export default function ColorSwatches({ variants, selected, onSelect, size = "lg", testPrefix = "swatch" }) {
  if (!variants || variants.length === 0) return null;
  const dim = size === "lg" ? "w-9 h-9" : "w-3.5 h-3.5";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testPrefix}-list`}>
      {variants.map((v, i) => {
        const active = selected === v.name;
        const off = !!v.sold_out;
        const label = off ? `${v.name} (sold out)` : v.name;
        const slash = off && <span className="absolute inset-0 rounded-full pointer-events-none" style={{ background: "linear-gradient(135deg, transparent 45%, #FDFBF6 45%, #FDFBF6 55%, transparent 55%)" }} />;
        const style = { background: v.hex, boxShadow: active ? "0 0 0 2px #FDFBF6, 0 0 0 4px #8A6A0F" : "inset 0 0 0 1px rgba(15,12,8,0.18)" };
        if (!onSelect) return <span key={i} title={label} className={`${dim} relative rounded-full inline-block ${off ? "opacity-40" : ""}`} style={style} data-testid={`${testPrefix}-${i}`}>{slash}</span>;
        return (
          <button key={i} type="button" title={label} aria-label={label} aria-pressed={active} disabled={off}
            onClick={() => onSelect(v)} className={`${dim} relative rounded-full transition-transform ${off ? "opacity-40 cursor-not-allowed" : "hover:scale-110"}`} style={style} data-testid={`${testPrefix}-${i}`}>{slash}</button>
        );
      })}
    </div>
  );
}
